import { Container, Text } from '@pixi/react'
import { TextStyle, Container as PixiContainer, Assets } from 'pixi.js'
import { formatToCommaWithLang, Image, t, toCommaOptions } from '@slot-nx/core'
import { gameConfig } from '../../config'
import { useEffect, useRef, useState } from 'react'
import { winBarService } from '../../domain/winning/service/winbarService'

import toatlWinBarImg from '../../../asset/images/winBar.png'
import { useGameStore } from '../../domain/game/store/GameStore'
Assets.add({
  alias: 'toatlWinBarImg',
  src: toatlWinBarImg,
  loadParser: 'loadTextures',
})

const totalWinStyle = new TextStyle({
  fill: '#fcc130',
  fontSize: 65,
  fontWeight: 'bold',
  dropShadow: true,
  dropShadowColor: '#341704',
  dropShadowBlur: 4,
  dropShadowAngle: Math.PI / 4,
  dropShadowDistance: 3,
  stroke: '#c06411',
  strokeThickness: 2,
})
const totalWinAmountStyle = new TextStyle({
  fill: '#fff',
  fontSize: 65,
  fontWeight: 'bold',
  stroke: '#fff',
  strokeThickness: 2,
  letterSpacing: 3,
})

export const TotalWinBar = () => {
  const totalWinBarRef = useRef<PixiContainer>()
  const freeGameAccumulatedPayout = useGameStore(x => x.freeGameAccumulatedPayout)

  const [winAmount, setwinAmount] = useState(0)
  useEffect(() => {
    winBarService.totalWinBarRef = totalWinBarRef.current as PixiContainer
  }, [])
  useEffect(() => {
    setwinAmount(freeGameAccumulatedPayout)
  }, [freeGameAccumulatedPayout])

  return (
    <Container
      alpha={0}
      name="total win"
      x={gameConfig.resolution.width / 2}
      y={gameConfig.resolution.height / 2 + 320}
      ref={(el: PixiContainer | null) => {
        totalWinBarRef.current = el as PixiContainer
      }}
    >
      <Image name="toatlWinBarImg" anchor={0.5} x={0} y={0} image="toatlWinBarImg" scale={1} />
      <Text name="winText" anchor={[0.5, 0.5]} x={-266} y={5} text={t('singlePayout_win')} style={totalWinStyle}></Text>
      <Text
        name="totalWinPayout"
        anchor={[0.5, 0.5]}
        y={0}
        x={70}
        text={`${formatToCommaWithLang(winAmount, navigator.language, toCommaOptions.forceTwoDecimalPlaces)}`}
        style={totalWinAmountStyle}
      >
      </Text>
      {/* <BitmapText
        name="totalWinPayout"
        text={`${formatToCommaWithLang(winAmount, navigator.language, toCommaOptions.forceTwoDecimalPlaces)}`}
        anchor={[0.5, 1]}
        style={{ fontName: 'FontW_WIN', fontSize: 33 }}
        y={-3.5}
        x={0}
      /> */}
    </Container>
  )
}
